import {useWalletFeatures} from '@product-web/shared--api-deimos/wallet'

export const useMinimumATUTransactionLimit = () => {
    const {data: walletFeatures} = useWalletFeatures()
    return walletFeatures?.autoTopupMinimumAmount
}
